import { render, staticRenderFns } from "./OrganizationalStructure.vue?vue&type=template&id=7725da17&scoped=true&"
import script from "./OrganizationalStructure.vue?vue&type=script&lang=js&"
export * from "./OrganizationalStructure.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationalStructure.vue?vue&type=style&index=0&id=7725da17&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7725da17",
  null
  
)

export default component.exports